export const API_STORE_LIST = `/rental/scm/store/listPage`;
export const API_GET_REST_DAY_LIST = '/rental/scm/store/restSchedule/listPage';
export const API_REST_DAY_ADD = '/rental/scm/store/restSchedule/add';
export const API_STORE_SERVICE_SCOPE_LIST = '/rental/scm/store/serviceArea/list';
export const API_STORE_LIST_SELECT = '/rental/scm/store/list';
export const API_STORE_SERVICE_SCOPE_CHANGE = '/rental/scm/store/serviceArea/addOrUpdate';
export const API_STORE_SCORE_INFO = '/rental/scm/store/getScore';

export const API_VEHICLE_BRAND_LIST = `/rental/scm/vehicle/brandList`;
export const API_VEHICLE_LIST = `/rental/scm/vehicle/pageList`;
export const API_VEHICLE_SREIES_LIST = `/rental/scm/vehicle/seriesList`;
export const API_VEHICLE_VEHICLE_LIST = `/rental/scm/vehicle/vehicleList`;
export const API_VEHICLE_UPLOAD_PHOTO = `${
	(window as any).GLOBAL_CARRENTAL_API_PREFIX
}/ota/rental/scm/file/upload?tag=common`;
export const API_VEHICLE_ADD = `/rental/scm/vehicle/add`;
export const API_VEHICLE_DETAIL = `/rental/scm/vehicle/detail`;
export const API_VEHICLE_EDIT_STATUS = `/rental/scm/vehicle/editStatus`;
export const API_VEHICLE_DELETE = `/rental/scm/vehicle/delete`;
export const API_VEHICLE_OCCUPY_LIST = `/rental/scm/vehicle/stockList`;
export const API_VEHICLE_OCCUPY_CONFIRM = `/rental/scm/vehicle/occupyStock`;
export const API_VEHICLE_OCCUPY_RELEASE = `/rental/scm/vehicle/releaseStock`;
export const API_VEHICLE_OCCUPY_SUMMARY_LIST = '/rental/scm/vehicle/calendarStock';

export const API_GET_CITY_LIST = '/rental/scm/store/filterItem';

export const API_GET_DIFF_CITY_RETURN_LIST = '/rental/scm/supplier/diffCityPRCarLine/listPage';
export const API_VEHICLE_EDIT = '/rental/scm/vehicle/edit';
export const API_VEHICLE_DOWNLOAD = '/rental/scm/file/download';
export const API_VEHICLE_BATCH_ADD = '/rental/scm/vehicle/batchAddWithOcr';
export const API_VEHICLE_GET_STORE = '/rental/scm/store/list';
export const API_VEHICLE_GET_MODEL_BY_VIN = '/rental/scm/vehicle/getModelByVin';
export const API_VEHICLE_EDIT_STORE = '/rental/scm/vehicle/editStore';
export const API_VEHICLE_BRAND_LIST_NEW = '/rental/scm/vehicle/storeBrandList';
export const API_VEHICLE_SERIES_LIST_NEW = '/rental/scm/vehicle/storeSeriesList';
export const API_VEHICLE_VEHICLE_LIST_NEW = '/rental/scm/vehicle/storeVehicleList';
export const API_UPLOAD_ZIP_BY_TYPE = `${
	(window as any).GLOBAL_CARRENTAL_API_PREFIX
}/ota/rental/scm/file/zipUploadByType?tag=common&file_type=`;
export const API_VEHICLE_UPLOAD_PHOTO_BY_TYPE = `${
	(window as any).GLOBAL_CARRENTAL_API_PREFIX
}/ota/rental/scm/file/uploadByType?tag=common&file_type=`;

export const API_UPLOAD_ID_CARD = `${(window as any).GLOBAL_CARRENTAL_API_PREFIX}/ota/rental/scm/file/upload?tag=id-card`;
export const API_UPLOAD_DRIVER_CARD = `${(window as any).GLOBAL_CARRENTAL_API_PREFIX}/ota/rental/scm/file/upload?tag=driver-card`;
export const API_UPLOAD_QUALIFICATION = `${(window as any).GLOBAL_CARRENTAL_API_PREFIX}/ota/rental/scm/file/upload?tag=qualification`;

export const API_UPLOAD_PR_CAR_VIDEO = `${(window as any).GLOBAL_CARRENTAL_API_PREFIX}/ota/rental/scm/file/zipUploadByType?tag=common&file_type=5`;

